/* ============================================================
   AVORA SHOP ALL — Client-side Filtering Engine
   Vanilla JS — no dependencies
   ============================================================ */
(function () {
  'use strict';

  /* ---- Parse data ---- */
  var dataEl = document.getElementById('avora-shop-data');
  if (!dataEl) return;
  var data;
  try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var allProducts = data.products || [];
  var departments = data.departments || [];
  var dailySaleActive = data.dailySaleEnabled === true && Number(data.dailySalePercentage) > 0;
  var dailySalePercentage = Number(data.dailySalePercentage) || 0;
  /* ---- Helpers ---- */
  function formatMoney(cents) {
    var moneyFormat = window.__shopMoneyFormat;
    var tokenMatch = typeof moneyFormat === 'string' ? moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/) : null;
    if (tokenMatch) {
      var token = tokenMatch[1];
      var precision = token.indexOf('no_decimals') > -1 ? 0 : 2;
      var thousands = token.indexOf('comma_separator') > -1 ? '.' : ',';
      var decimal = token.indexOf('comma_separator') > -1 ? ',' : '.';
      if (token.indexOf('apostrophe_separator') > -1) { thousands = "'"; decimal = '.'; }
      var amount = (cents / 100).toFixed(precision).split('.');
      amount[0] = amount[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return moneyFormat.replace(tokenMatch[0], precision > 0 ? amount[0] + decimal + amount[1] : amount[0]);
    }
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || window.__shopCurrencyCode || 'EUR';
    var locale = document.documentElement.lang || 'en';
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  function salePrice(cents) {
    return dailySaleActive ? cents - Math.floor(cents * dailySalePercentage / 100) : cents;
  }

  function getMaxPrice() {
    var max = 0;
    for (var i = 0; i < allProducts.length; i++) {
      if (salePrice(allProducts[i].price) > max) max = salePrice(allProducts[i].price);
    }
    return Math.ceil(max / 100);
  }

  function extractTags(prefix) {
    var map = {};
    var pLen = prefix.length;
    for (var i = 0; i < allProducts.length; i++) {
      var tags = allProducts[i].tags;
      for (var j = 0; j < tags.length; j++) {
        var t = tags[j].toLowerCase();
        if (t.substring(0, pLen) === prefix) {
          var val = t.substring(pLen);
          if (val) map[val] = (map[val] || 0) + 1;
        }
      }
    }
    return Object.keys(map).sort().map(function (k) { return { value: k, label: k.replace(/-/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); }), count: map[k] }; });
  }

  function $(id) { return document.getElementById(id); }
  function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }

  /* ---- Color map ---- */
  var COLOR_MAP = {
    'black': '#2C2824', 'brown': '#8B6F4E', 'white': '#F5F0EB',
    'natural': '#D4BC96', 'green': '#6B7F5E', 'gray': '#9C9590', 'grey': '#9C9590',
    'gold': '#C4A882', 'walnut': '#5C3D2E', 'beige': '#D4C5A9',
    'blue': '#6B7F9E', 'red': '#9E6B6B', 'pink': '#C4A0A0',
    'orange': '#C4A06B', 'yellow': '#C4B882', 'silver': '#B8B8B8', 'cream': '#F0E6D3'
  };

  /* ---- State ---- */
  var maxPrice = getMaxPrice() || 500;
  var state = {
    categories: [],
    priceMin: 0,
    priceMax: maxPrice,
    materials: [],
    rooms: [],
    colors: [],
    sort: 'featured',
    page: 1,
    perPage: 50,
    gridCols: parseInt(localStorage.getItem('avora-shop-cols') || '4', 10)
  };

  /* ---- DOM refs ---- */
  var elGrid = $('avora-shop-grid');
  var elCount = $('avora-shop-count');
  var elEmpty = $('avora-shop-empty');
  var elPagination = $('avora-shop-pagination');
  var elPaginationInfo = $('avora-shop-pagination-info');
  var elPageNumbers = $('avora-shop-page-numbers');
  var elPagePrev = $('avora-shop-page-prev');
  var elPageNext = $('avora-shop-page-next');
  var elPills = $('avora-shop-pills');
  var elPillsList = $('avora-shop-pills-list');
  var elBar = $('avora-shop-bar');
  var elBadge = $('avora-shop-filter-badge');
  var elSidebar = $('avora-shop-sidebar');
  var elSidebarShowing = $('avora-shop-sidebar-showing');
  var elDrawerOverlay = $('avora-shop-drawer-overlay');
  var elDrawer = $('avora-shop-drawer');
  var elDrawerBody = $('avora-shop-drawer-body');
  var elDrawerCount = $('avora-shop-drawer-count');
  var elSortOverlay = $('avora-shop-sort-overlay');
  var elSortDrawer = $('avora-shop-sort-drawer');

  /* ---- Filter data ---- */
  var materials = extractTags('material:');
  var rooms = extractTags('room:');
  var colors = extractTags('color:');

  /* ============================================================
     URL STATE
     ============================================================ */
  function restoreFromURL() {
    var params = new URLSearchParams(window.location.search);
    if (params.get('category')) state.categories = params.get('category').split(',');
    if (params.get('price')) {
      var p = params.get('price').split('-');
      state.priceMin = parseInt(p[0], 10) || 0;
      state.priceMax = parseInt(p[1], 10) || maxPrice;
    }
    if (params.get('material')) state.materials = params.get('material').split(',');
    if (params.get('room')) state.rooms = params.get('room').split(',');
    if (params.get('color')) state.colors = params.get('color').split(',');
    if (params.get('sort')) state.sort = params.get('sort');
    if (params.get('cols')) state.gridCols = parseInt(params.get('cols'), 10);
  }

  function syncToURL() {
    var params = new URLSearchParams();
    if (state.categories.length) params.set('category', state.categories.join(','));
    if (state.priceMin > 0 || state.priceMax < maxPrice) params.set('price', state.priceMin + '-' + state.priceMax);
    if (state.materials.length) params.set('material', state.materials.join(','));
    if (state.rooms.length) params.set('room', state.rooms.join(','));
    if (state.colors.length) params.set('color', state.colors.join(','));
    if (state.sort !== 'featured') params.set('sort', state.sort);
    var qs = params.toString();
    var url = window.location.pathname + (qs ? '?' + qs : '');
    history.replaceState(null, '', url);
  }

  /* ============================================================
     FILTERING
     ============================================================ */
  function getAllSubHandles(handle) {
    for (var i = 0; i < departments.length; i++) {
      if (departments[i].handle === handle) {
        return [handle].concat(departments[i].subs.map(function (s) { return s.handle; }));
      }
    }
    return [handle];
  }

  function applyFilters() {
    var expandedCats = [];
    state.categories.forEach(function (cat) {
      expandedCats = expandedCats.concat(getAllSubHandles(cat));
    });
    // Deduplicate
    var catSet = {};
    expandedCats.forEach(function (c) { catSet[c] = true; });
    var catArr = Object.keys(catSet);

    return allProducts.filter(function (p) {
      // Categories
      if (catArr.length > 0) {
        var match = false;
        for (var i = 0; i < p.collections.length; i++) {
          if (catSet[p.collections[i]]) { match = true; break; }
        }
        if (!match) return false;
      }
      // Price
      var price = salePrice(p.price) / 100;
      if (price < state.priceMin || price > state.priceMax) return false;
      // Materials
      if (state.materials.length > 0) {
        var hasMat = false;
        for (var i = 0; i < state.materials.length; i++) {
          var tag = 'material:' + state.materials[i];
          for (var j = 0; j < p.tags.length; j++) {
            if (p.tags[j].toLowerCase() === tag) { hasMat = true; break; }
          }
          if (hasMat) break;
        }
        if (!hasMat) return false;
      }
      // Rooms
      if (state.rooms.length > 0) {
        var hasRoom = false;
        for (var i = 0; i < state.rooms.length; i++) {
          var tag = 'room:' + state.rooms[i];
          for (var j = 0; j < p.tags.length; j++) {
            if (p.tags[j].toLowerCase() === tag) { hasRoom = true; break; }
          }
          if (hasRoom) break;
        }
        if (!hasRoom) return false;
      }
      // Colors
      if (state.colors.length > 0) {
        var hasColor = false;
        for (var i = 0; i < state.colors.length; i++) {
          var tag = 'color:' + state.colors[i];
          for (var j = 0; j < p.tags.length; j++) {
            if (p.tags[j].toLowerCase() === tag) { hasColor = true; break; }
          }
          if (hasColor) break;
        }
        if (!hasColor) return false;
      }
      return true;
    }).sort(function (a, b) {
      switch (state.sort) {
        case 'price-asc': return a.price - b.price;
        case 'price-desc': return b.price - a.price;
        case 'newest': return (b.createdAt || '').localeCompare(a.createdAt || '');
        case 'alpha': return (a.title || '').localeCompare(b.title || '');
        default: return 0; // featured = original order
      }
    });
  }

  /* Compute counts for filter options based on OTHER active filters */
  function computeCounts(filtered) {
    var counts = { categories: {}, materials: {}, rooms: {}, colors: {} };

    /* For category counts: filter products WITHOUT category filter applied */
    var noCatProducts = allProducts.filter(function (p) {
      var price = salePrice(p.price) / 100;
      if (price < state.priceMin || price > state.priceMax) return false;
      if (state.materials.length > 0) {
        var hasMat = false;
        for (var i = 0; i < state.materials.length; i++) {
          for (var j = 0; j < p.tags.length; j++) {
            if (p.tags[j].toLowerCase() === 'material:' + state.materials[i]) { hasMat = true; break; }
          }
          if (hasMat) break;
        }
        if (!hasMat) return false;
      }
      if (state.rooms.length > 0) {
        var hasRoom = false;
        for (var i = 0; i < state.rooms.length; i++) {
          for (var j = 0; j < p.tags.length; j++) {
            if (p.tags[j].toLowerCase() === 'room:' + state.rooms[i]) { hasRoom = true; break; }
          }
          if (hasRoom) break;
        }
        if (!hasRoom) return false;
      }
      if (state.colors.length > 0) {
        var hasColor = false;
        for (var i = 0; i < state.colors.length; i++) {
          for (var j = 0; j < p.tags.length; j++) {
            if (p.tags[j].toLowerCase() === 'color:' + state.colors[i]) { hasColor = true; break; }
          }
          if (hasColor) break;
        }
        if (!hasColor) return false;
      }
      return true;
    });

    departments.forEach(function (dept) {
      var allHandles = [dept.handle].concat(dept.subs.map(function (s) { return s.handle; }));
      var count = 0;
      noCatProducts.forEach(function (p) {
        for (var i = 0; i < p.collections.length; i++) {
          if (allHandles.indexOf(p.collections[i]) !== -1) { count++; break; }
        }
      });
      counts.categories[dept.handle] = count;
      dept.subs.forEach(function (sub) {
        var sc = 0;
        noCatProducts.forEach(function (p) {
          if (p.collections.indexOf(sub.handle) !== -1) sc++;
        });
        counts.categories[sub.handle] = sc;
      });
    });

    /* For material/room/color counts: use the fully filtered set */
    filtered.forEach(function (p) {
      p.tags.forEach(function (t) {
        var tl = t.toLowerCase();
        if (tl.indexOf('material:') === 0) {
          var v = tl.substring(9);
          counts.materials[v] = (counts.materials[v] || 0) + 1;
        } else if (tl.indexOf('room:') === 0) {
          var v = tl.substring(5);
          counts.rooms[v] = (counts.rooms[v] || 0) + 1;
        } else if (tl.indexOf('color:') === 0) {
          var v = tl.substring(6);
          counts.colors[v] = (counts.colors[v] || 0) + 1;
        }
      });
    });

    return counts;
  }

  /* ============================================================
     RENDER: Product Card — Shop All glass-panel style
     ============================================================ */
  var colorMap = {
    'black': '#2C2824', 'white': '#F5F0EB', 'brown': '#8B6F4E',
    'natural': '#D4BC96', 'walnut': '#5C3D2E', 'bamboo': '#C4A882',
    'gold': '#C4A882', 'silver': '#9C9590', 'gray': '#9C9590',
    'grey': '#9C9590', 'green': '#6B7F5E', 'blue': '#5E6B7F',
    'beige': '#D4C4A8', 'oak': '#B5956E', 'cream': '#F0E6D3',
    'red': '#8B4F4F', 'pink': '#C4928A', 'copper': '#B87333',
    'brass': '#C5A55A', 'wood': '#A0785A', 'dark': '#3E3530',
    'light': '#E8DED2', 'charcoal': '#4A4541', 'sand': '#D4C4A8',
    'taupe': '#9B8F84', 'ivory': '#F5F0E8', 'rust': '#A0522D',
    'navy': '#3A4556', 'teal': '#4F7C7A', 'olive': '#6B6B4E',
    'steel': '#71797E', 'matte': '#6B6560', 'chrome': '#C0C0C0',
    'rose': '#C4928A', 'marble': '#E8E0D8', 'concrete': '#A0998F'
  };

  // Cycle through warm palette for variants that don't match any known color name
  var fallbackColors = ['#9C9590', '#B5956E', '#7A8B6F', '#8B7F6E', '#6B7F7F'];

  function matchColor(name) {
    var lower = name.toLowerCase();
    for (var key in colorMap) {
      if (lower.indexOf(key) !== -1) return colorMap[key];
    }
    return null;
  }

  function renderVariantDots(product) {
    if (!product.variantNames || product.variantNames.length <= 1) return '';

    var desktopDotLimit = 4;
    var mobileDotLimit = 2;
    var totalVariantCount = Math.max(Number(product.variantCount) || 0, product.variantNames.length);
    var dots = product.variantNames.slice(0, desktopDotLimit).map(function(name, i) {
      var hex = matchColor(name) || fallbackColors[i % fallbackColors.length];
      var isGradient = hex.indexOf('gradient') !== -1;
      var bgStyle = isGradient ? 'background:' + hex : 'background-color:' + hex;
      var activeClass = '';
      return '<button type="button" class="avora-card--shop__variant-dot' + activeClass + '" ' +
             'data-variant-index="' + i + '" ' +
             'title="' + esc(name) + '" ' +
             'style="' + bgStyle + '" ' +
             'aria-label="' + esc(name) + '"></button>';
    }).join('');

    if (totalVariantCount > desktopDotLimit) {
      dots += '<span class="avora-card--shop__variant-more avora-card--shop__variant-more--desktop" aria-label="' + (totalVariantCount - desktopDotLimit) + ' more options">+' + (totalVariantCount - desktopDotLimit) + '</span>';
    }
    if (totalVariantCount > mobileDotLimit) {
      dots += '<span class="avora-card--shop__variant-more avora-card--shop__variant-more--mobile" aria-label="' + (totalVariantCount - mobileDotLimit) + ' more options">+' + (totalVariantCount - mobileDotLimit) + '</span>';
    }
    return '<div class="avora-card--shop__variants">' + dots + '</div>';
  }

  function renderCard(product, index) {
    // Badge
    var badgeHTML = '';
    if (dailySaleActive) {
      badgeHTML = '<span class="avora-card--shop__badge avora-card--shop__badge--sale">-' + dailySalePercentage + '%</span>';
    } else if (product.isNew) {
      badgeHTML = '<span class="avora-card--shop__badge">NEW</span>';
    }

    // Price
    var priceHTML = '';
    if (dailySaleActive) {
      priceHTML += '<span class="avora-card--shop__price-compare">' + formatMoney(product.priceMin) + '</span>';
    }
    if (product.priceVaries) {
      priceHTML += '<span class="avora-card--shop__price">From ' + formatMoney(salePrice(product.priceMin)) + '</span>';
    } else {
      priceHTML += '<span class="avora-card--shop__price">' + formatMoney(salePrice(product.price)) + '</span>';
    }

    // Variant dots
    var dotsHTML = renderVariantDots(product);

    // Quick-add button
    var addBtnHTML = '';
    if (product.available && product.variantId) {
      addBtnHTML = '<button type="button" class="avora-card--shop__add" data-variant-id="' + product.variantId + '" data-product-title="' + esc(product.title) + '" data-product-image="' + esc(product.image) + '" data-product-price="' + esc(formatMoney(salePrice(product.price))) + '" aria-label="Add ' + esc(product.title) + ' to cart" onclick="event.preventDefault();event.stopPropagation();window.avoraShopQuickAdd(this);">' +
        '<svg class="avora-card--shop__icon-plus" width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M7 1v12M1 7h12" stroke="white" stroke-width="1.5" stroke-linecap="round"/></svg>' +
        '<svg class="avora-card--shop__icon-check" width="14" height="14" viewBox="0 0 14 14" fill="none"><polyline points="2 7 5.5 10.5 12 3.5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '</button>';
    }

    // Review stars (gold, matches the rest of the theme) — only when published reviews exist
    var starsHTML = '';
    if (product.reviewCount > 0 && product.rating > 0) {
      var ratingPct = Math.round(product.rating * 20);
      var oneStar = '<svg class="avora-stars__s" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77 5.82 21.02 7 14.14 2 9.27l6.91-1.01z" fill="currentColor"/></svg>';
      var fiveStars = oneStar + oneStar + oneStar + oneStar + oneStar;
      starsHTML = '<span class="avora-stars avora-stars--sm"><span class="avora-stars__row" role="img" aria-label="Rated ' + product.rating + ' out of 5 (' + product.reviewCount + ' reviews)"><span class="avora-stars__base">' + fiveStars + '</span><span class="avora-stars__fill" style="width:' + ratingPct + '%">' + fiveStars + '</span></span><span class="avora-stars__count">(' + product.reviewCount + ')</span></span>';
    }

    return '<div class="avora-card--shop" data-product-handle="' + esc(product.handle) + '" style="--card-index:' + index + '">' +
      '<a href="' + esc(product.url) + '" class="avora-card--shop__link" aria-label="' + esc(product.title) + '">' +
        '<div class="avora-card--shop__image-wrap">' +
          badgeHTML +
          (product.image ? '<img src="' + esc(product.image) + '" alt="' + esc(product.imageAlt) + '" class="avora-card--shop__image" data-images=\'' + JSON.stringify(product.variantImages || []).replace(/'/g, '&#39;') + '\' loading="lazy" width="600" height="600">' : '<div class="avora-card--shop__placeholder"></div>') +
        '</div>' +
        '<div class="avora-card--shop__panel">' +
          '<h3 class="avora-card--shop__title">' + esc(product.title) + '</h3>' +
          starsHTML +
          '<div class="avora-card--shop__prices">' +
            priceHTML +
          '</div>' +
          '<div class="avora-card--shop__panel-bottom">' +
            dotsHTML +
            addBtnHTML +
          '</div>' +
        '</div>' +
      '</a>' +
    '</div>';
  }

  /* ============================================================
     RENDER: Grid
     ============================================================ */
  var currentFiltered = [];

  function renderGrid(filtered, animate) {
    currentFiltered = filtered;
    var totalPages = Math.ceil(filtered.length / state.perPage);
    if (state.page > totalPages) state.page = Math.max(1, totalPages);

    var start = (state.page - 1) * state.perPage;
    var end = Math.min(start + state.perPage, filtered.length);
    var visible = filtered.slice(start, end);

    if (animate) {
      elGrid.classList.add('is-transitioning');
      requestAnimationFrame(function () {
        setTimeout(function () {
          writeGrid(visible);
          elGrid.classList.remove('is-transitioning');
        }, 160);
      });
    } else {
      writeGrid(visible);
    }

    // Empty / pagination
    elEmpty.hidden = filtered.length > 0;
    elGrid.style.display = filtered.length > 0 ? '' : 'none';

    // Pagination — always show info, only show controls when multi-page
    if (elPagination) {
      elPagination.hidden = filtered.length === 0;
    }
    if (elPaginationInfo) {
      elPaginationInfo.textContent = filtered.length > 0
        ? 'Showing ' + (start + 1) + '–' + end + ' of ' + filtered.length + ' products'
        : '';
    }
    var controlsEl = document.querySelector('.avora-shop__pagination-controls');
    if (controlsEl) controlsEl.style.display = totalPages <= 1 ? 'none' : '';
    renderPageNumbers(totalPages);
  }

  function writeGrid(visible) {
    var html = '';
    for (var i = 0; i < visible.length; i++) {
      html += renderCard(visible[i], i);
    }
    elGrid.innerHTML = html;
  }

  /* ============================================================
     RENDER: Sidebar Filters
     ============================================================ */

  /* Category tree */
  function renderCategoryTree(counts) {
    var container = $('avora-shop-category-tree');
    if (!container) return;
    if (departments.length === 0) {
      container.innerHTML = '<p class="avora-shop__no-filters">No categories available</p>';
      return;
    }
    var html = '';
    departments.forEach(function (dept) {
      var isActive = state.categories.indexOf(dept.handle) !== -1;
      var isOpen = isActive || dept.subs.some(function (s) { return state.categories.indexOf(s.handle) !== -1; });
      var count = counts.categories[dept.handle] || 0;
      html += '<div class="avora-shop__cat-dept">';
      html += '<button class="avora-shop__cat-dept-btn' + (isActive ? ' is-active' : '') + '" data-handle="' + esc(dept.handle) + '">';
      html += '<span class="avora-shop__cat-expand' + (isOpen ? ' is-open' : '') + '"><svg width="8" height="8" viewBox="0 0 8 8" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M2 1l4 3-4 3"/></svg></span>';
      html += '<span class="avora-shop__cat-indicator"></span>';
      html += '<span class="avora-shop__cat-dept-label">' + esc(dept.label) + '</span>';
      html += '<span class="avora-shop__cat-count">(' + count + ')</span>';
      html += '</button>';
      if (dept.subs.length > 0) {
        html += '<div class="avora-shop__cat-subs' + (isOpen ? ' is-open' : '') + '">';
        dept.subs.forEach(function (sub) {
          var subActive = state.categories.indexOf(sub.handle) !== -1;
          var subCount = counts.categories[sub.handle] || 0;
          html += '<button class="avora-shop__cat-sub-btn' + (subActive ? ' is-active' : '') + '" data-handle="' + esc(sub.handle) + '">';
          html += '<span class="avora-shop__cat-indicator"></span>';
          html += '<span class="avora-shop__cat-dept-label">' + esc(sub.label) + '</span>';
          html += '<span class="avora-shop__cat-count">(' + subCount + ')</span>';
          html += '</button>';
        });
        html += '</div>';
      }
      html += '</div>';
    });
    container.innerHTML = html;

    /* Events */
    container.querySelectorAll('.avora-shop__cat-dept-btn').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        var handle = btn.dataset.handle;
        var expand = btn.querySelector('.avora-shop__cat-expand');
        var subs = btn.parentElement.querySelector('.avora-shop__cat-subs');

        /* If clicking the chevron area, just toggle expand */
        if (e.target.closest('.avora-shop__cat-expand')) {
          if (expand) expand.classList.toggle('is-open');
          if (subs) subs.classList.toggle('is-open');
          return;
        }

        /* Toggle category selection */
        toggleArrayValue(state.categories, handle);
        state.page = 1;
        update(true);
      });
    });

    container.querySelectorAll('.avora-shop__cat-sub-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        toggleArrayValue(state.categories, btn.dataset.handle);
        state.page = 1;
        update(true);
      });
    });
  }

  /* Checkbox filter (material, room) */
  function renderCheckboxFilter(containerId, items, stateKey, counts) {
    var container = $(containerId);
    if (!container) return;
    var section = container.closest('.avora-shop__filter-section');
    if (items.length === 0) {
      container.innerHTML = '';
      if (section) section.style.display = 'none';
      return;
    }
    if (section) section.style.display = '';
    var html = '<ul class="avora-shop__check-list">';
    items.forEach(function (item) {
      var isActive = state[stateKey].indexOf(item.value) !== -1;
      var count = (counts && counts[item.value]) || 0;
      html += '<li class="avora-shop__check-item">';
      html += '<button class="avora-shop__check-label' + (isActive ? ' is-active' : '') + '" data-value="' + esc(item.value) + '">';
      html += '<span class="avora-shop__checkbox"><svg class="avora-shop__checkbox-check" width="10" height="10" viewBox="0 0 10 10" fill="none" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="2 5 4 7 8 3"/></svg></span>';
      html += '<span class="avora-shop__check-name">' + esc(item.label) + '</span>';
      html += '<span class="avora-shop__check-count">(' + count + ')</span>';
      html += '</button></li>';
    });
    html += '</ul>';
    container.innerHTML = html;

    container.querySelectorAll('.avora-shop__check-label').forEach(function (btn) {
      btn.addEventListener('click', function () {
        toggleArrayValue(state[stateKey], btn.dataset.value);
        state.page = 1;
        update(true);
      });
    });
  }

  /* Color swatches */
  function renderColorFilter(counts) {
    var container = $('avora-shop-color-filter');
    if (!container) return;
    var section = container.closest('.avora-shop__filter-section');
    if (colors.length === 0) {
      container.innerHTML = '';
      if (section) section.style.display = 'none';
      return;
    }
    if (section) section.style.display = '';
    var html = '<div class="avora-shop__color-grid">';
    colors.forEach(function (c) {
      var isActive = state.colors.indexOf(c.value) !== -1;
      var hex = COLOR_MAP[c.value] || '#CCC';
      html += '<button class="avora-shop__color-swatch' + (isActive ? ' is-active' : '') + '" data-value="' + esc(c.value) + '" title="' + esc(c.label) + '">';
      html += '<span class="avora-shop__color-circle" style="background:' + hex + '"></span>';
      html += '<span class="avora-shop__color-label">' + esc(c.label) + '</span>';
      html += '</button>';
    });
    html += '</div>';
    container.innerHTML = html;

    container.querySelectorAll('.avora-shop__color-swatch').forEach(function (btn) {
      btn.addEventListener('click', function () {
        toggleArrayValue(state.colors, btn.dataset.value);
        state.page = 1;
        update(true);
      });
    });
  }

  function toggleArrayValue(arr, val) {
    var idx = arr.indexOf(val);
    if (idx === -1) arr.push(val);
    else arr.splice(idx, 1);
  }

  /* ============================================================
     PRICE SLIDER
     ============================================================ */
  function initPriceSlider() {
    var slider = $('avora-shop-price-slider');
    var handleMin = $('avora-shop-price-handle-min');
    var handleMax = $('avora-shop-price-handle-max');
    var active = $('avora-shop-price-active');
    var minLabel = $('avora-shop-price-min-label');
    var maxLabel = $('avora-shop-price-max-label');
    if (!slider || !handleMin || !handleMax) return;

    function positionHandles() {
      var w = slider.offsetWidth;
      var minPct = (state.priceMin / maxPrice) * 100;
      var maxPct = (state.priceMax / maxPrice) * 100;
      handleMin.style.left = minPct + '%';
      handleMax.style.left = maxPct + '%';
      active.style.left = minPct + '%';
      active.style.width = (maxPct - minPct) + '%';
      if (minLabel) minLabel.textContent = '€' + state.priceMin;
      if (maxLabel) maxLabel.textContent = state.priceMax >= maxPrice ? '€' + maxPrice + '+' : '€' + state.priceMax;
    }

    positionHandles();

    function startDrag(handle, isMin) {
      return function (e) {
        e.preventDefault();
        handle.classList.add('is-dragging');
        var rect = slider.getBoundingClientRect();

        function onMove(ev) {
          var clientX = ev.touches ? ev.touches[0].clientX : ev.clientX;
          var pct = Math.max(0, Math.min(1, (clientX - rect.left) / rect.width));
          var val = Math.round(pct * maxPrice);

          if (isMin) {
            state.priceMin = Math.min(val, state.priceMax - 1);
          } else {
            state.priceMax = Math.max(val, state.priceMin + 1);
          }
          positionHandles();
          updatePresetHighlight();
        }

        function onEnd() {
          handle.classList.remove('is-dragging');
          document.removeEventListener('mousemove', onMove);
          document.removeEventListener('mouseup', onEnd);
          document.removeEventListener('touchmove', onMove);
          document.removeEventListener('touchend', onEnd);
          state.page = 1;
          update(true);
        }

        document.addEventListener('mousemove', onMove);
        document.addEventListener('mouseup', onEnd);
        document.addEventListener('touchmove', onMove, { passive: false });
        document.addEventListener('touchend', onEnd);
      };
    }

    handleMin.addEventListener('mousedown', startDrag(handleMin, true));
    handleMin.addEventListener('touchstart', startDrag(handleMin, true), { passive: false });
    handleMax.addEventListener('mousedown', startDrag(handleMax, false));
    handleMax.addEventListener('touchstart', startDrag(handleMax, false), { passive: false });

    /* Price presets */
    var presets = document.querySelectorAll('.avora-shop__price-preset');
    presets.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var min = parseInt(btn.dataset.min, 10);
        var max = parseInt(btn.dataset.max, 10);
        if (max > maxPrice) max = maxPrice;
        // Toggle off if already active
        if (state.priceMin === min && state.priceMax === max) {
          state.priceMin = 0;
          state.priceMax = maxPrice;
        } else {
          state.priceMin = min;
          state.priceMax = max;
        }
        positionHandles();
        updatePresetHighlight();
        state.page = 1;
        update(true);
      });
    });

    function updatePresetHighlight() {
      presets.forEach(function (btn) {
        var min = parseInt(btn.dataset.min, 10);
        var max = parseInt(btn.dataset.max, 10);
        if (max > maxPrice) max = maxPrice;
        btn.classList.toggle('is-active', state.priceMin === min && state.priceMax === max);
      });
    }

    updatePresetHighlight();

    /* Expose for update calls */
    window._avoraShopPricePosition = positionHandles;
    window._avoraShopPresetHighlight = updatePresetHighlight;
  }

  /* ============================================================
     ACTIVE FILTER PILLS
     ============================================================ */
  function renderPills() {
    var pills = [];
    var closeSvg = '<svg width="8" height="8" viewBox="0 0 8 8" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><line x1="1" y1="1" x2="7" y2="7"/><line x1="7" y1="1" x2="1" y2="7"/></svg>';

    state.categories.forEach(function (cat) {
      var label = cat;
      departments.forEach(function (d) {
        if (d.handle === cat) label = d.label;
        d.subs.forEach(function (s) { if (s.handle === cat) label = s.label; });
      });
      pills.push('<button class="avora-shop__pill" data-type="category" data-value="' + esc(cat) + '">' + esc(label) + ' ' + closeSvg + '</button>');
    });

    if (state.priceMin > 0 || state.priceMax < maxPrice) {
      var pLabel = '€' + state.priceMin + ' – €' + state.priceMax;
      pills.push('<button class="avora-shop__pill" data-type="price">' + esc(pLabel) + ' ' + closeSvg + '</button>');
    }

    state.materials.forEach(function (m) {
      var label = m.replace(/-/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
      pills.push('<button class="avora-shop__pill" data-type="material" data-value="' + esc(m) + '">' + esc(label) + ' ' + closeSvg + '</button>');
    });

    state.rooms.forEach(function (r) {
      var label = r.replace(/-/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
      pills.push('<button class="avora-shop__pill" data-type="room" data-value="' + esc(r) + '">' + esc(label) + ' ' + closeSvg + '</button>');
    });

    state.colors.forEach(function (c) {
      var label = c.replace(/-/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
      pills.push('<button class="avora-shop__pill" data-type="color" data-value="' + esc(c) + '">' + esc(label) + ' ' + closeSvg + '</button>');
    });

    elPillsList.innerHTML = pills.join('');
    elPills.hidden = pills.length === 0;

    /* Badge */
    var totalFilters = state.categories.length + state.materials.length + state.rooms.length + state.colors.length + (state.priceMin > 0 || state.priceMax < maxPrice ? 1 : 0);
    elBadge.textContent = totalFilters;
    elBadge.hidden = totalFilters === 0;

    /* Pill click handlers */
    elPillsList.querySelectorAll('.avora-shop__pill').forEach(function (pill) {
      pill.addEventListener('click', function () {
        var type = pill.dataset.type;
        var val = pill.dataset.value;
        if (type === 'category') toggleArrayValue(state.categories, val);
        else if (type === 'price') { state.priceMin = 0; state.priceMax = maxPrice; if (window._avoraShopPricePosition) window._avoraShopPricePosition(); if (window._avoraShopPresetHighlight) window._avoraShopPresetHighlight(); }
        else if (type === 'material') toggleArrayValue(state.materials, val);
        else if (type === 'room') toggleArrayValue(state.rooms, val);
        else if (type === 'color') toggleArrayValue(state.colors, val);
        state.page = 1;
        update(true);
      });
    });
  }

  /* ============================================================
     CLEAR ALL
     ============================================================ */
  function clearAll() {
    state.categories = [];
    state.priceMin = 0;
    state.priceMax = maxPrice;
    state.materials = [];
    state.rooms = [];
    state.colors = [];
    state.page = 1;
    if (window._avoraShopPricePosition) window._avoraShopPricePosition();
    if (window._avoraShopPresetHighlight) window._avoraShopPresetHighlight();
    update(true);
  }

  [$('avora-shop-clear-all'), $('avora-shop-sidebar-clear'), $('avora-shop-empty-clear'), $('avora-shop-drawer-clear')].forEach(function (el) {
    if (el) el.addEventListener('click', clearAll);
  });

  /* ============================================================
     SORT
     ============================================================ */
  var sortLabels = { 'featured': 'Featured', 'price-asc': 'Price: Low to High', 'price-desc': 'Price: High to Low', 'newest': 'Newest', 'alpha': 'A – Z' };

  /* Desktop sort dropdown */
  var sortBtn = $('avora-shop-sort-btn');
  var sortMenu = $('avora-shop-sort-menu');
  var sortLabel = $('avora-shop-sort-label');

  if (sortBtn && sortMenu) {
    sortBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      sortMenu.hidden = !sortMenu.hidden;
    });
    sortMenu.querySelectorAll('.avora-shop__bar-dropdown-item').forEach(function (item) {
      item.addEventListener('click', function () {
        state.sort = item.dataset.sort;
        state.page = 1;
        if (sortLabel) sortLabel.textContent = 'Sort by: ' + sortLabels[state.sort];
        sortMenu.querySelectorAll('.avora-shop__bar-dropdown-item').forEach(function (i) { i.classList.remove('is-active'); });
        item.classList.add('is-active');
        sortMenu.hidden = true;
        update(true);
      });
    });
  }

  /* Quick category dropdown */
  var catDropBtn = $('avora-shop-cat-dropdown-btn');
  var catDropMenu = $('avora-shop-cat-dropdown-menu');
  var catDropLabel = $('avora-shop-cat-dropdown-label');

  if (catDropBtn && catDropMenu) {
    catDropBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      catDropMenu.hidden = !catDropMenu.hidden;
    });
    catDropMenu.querySelectorAll('.avora-shop__bar-dropdown-item').forEach(function (item) {
      item.addEventListener('click', function () {
        var handle = item.dataset.catHandle;
        if (handle === '') {
          state.categories = [];
        } else {
          state.categories = [handle];
        }
        state.page = 1;
        if (catDropLabel) catDropLabel.textContent = handle ? item.textContent : 'Category';
        catDropMenu.querySelectorAll('.avora-shop__bar-dropdown-item').forEach(function (i) { i.classList.remove('is-active'); });
        item.classList.add('is-active');
        catDropMenu.hidden = true;
        update(true);
      });
    });
  }

  /* Close dropdowns on outside click */
  document.addEventListener('click', function () {
    if (sortMenu) sortMenu.hidden = true;
    if (catDropMenu) catDropMenu.hidden = true;
  });

  /* ============================================================
     GRID TOGGLE
     ============================================================ */
  var gridToggle = $('avora-shop-grid-toggle');
  if (gridToggle) {
    gridToggle.querySelectorAll('.avora-shop__grid-btn').forEach(function (btn) {
      if (parseInt(btn.dataset.cols, 10) === state.gridCols) {
        btn.classList.add('is-active');
      } else {
        btn.classList.remove('is-active');
      }
      btn.addEventListener('click', function () {
        state.gridCols = parseInt(btn.dataset.cols, 10);
        elGrid.dataset.cols = state.gridCols;
        localStorage.setItem('avora-shop-cols', state.gridCols);
        gridToggle.querySelectorAll('.avora-shop__grid-btn').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
      });
    });
  }

  /* ============================================================
     PAGINATION
     ============================================================ */
  function renderPageNumbers(totalPages) {
    if (!elPageNumbers) return;
    var html = '';
    var current = state.page;

    var pages = [];
    if (totalPages <= 7) {
      for (var i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      pages.push(1);
      if (current > 3) pages.push('...');
      var rangeStart = Math.max(2, current - 1);
      var rangeEnd = Math.min(totalPages - 1, current + 1);
      if (current <= 3) rangeEnd = 4;
      if (current >= totalPages - 2) rangeStart = totalPages - 3;
      for (var i = rangeStart; i <= rangeEnd; i++) pages.push(i);
      if (current < totalPages - 2) pages.push('...');
      pages.push(totalPages);
    }

    pages.forEach(function(p) {
      if (p === '...') {
        html += '<span class="avora-shop__page-ellipsis">&hellip;</span>';
      } else {
        html += '<button class="avora-shop__page-num' + (p === current ? ' is-active' : '') + '" data-page="' + p + '">' + p + '</button>';
      }
    });
    elPageNumbers.innerHTML = html;

    if (elPagePrev) elPagePrev.disabled = current <= 1;
    if (elPageNext) elPageNext.disabled = current >= totalPages;
  }

  function goToPage(page) {
    if (page === state.page) return;
    state.page = page;
    update(true);

    // Scroll to top of grid
    var gridArea = document.querySelector('.avora-shop__grid-area');
    if (gridArea) {
      gridArea.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  // Event delegation — single listener for all pagination clicks
  if (elPagination) {
    elPagination.addEventListener('click', function(e) {
      var numBtn = e.target.closest('.avora-shop__page-num');
      if (numBtn) {
        goToPage(parseInt(numBtn.dataset.page, 10));
        return;
      }
      var prevBtn = e.target.closest('.avora-shop__page-prev');
      if (prevBtn && state.page > 1) {
        goToPage(state.page - 1);
        return;
      }
      var nextBtn = e.target.closest('.avora-shop__page-next');
      if (nextBtn) {
        var totalPages = Math.ceil(currentFiltered.length / state.perPage);
        if (state.page < totalPages) goToPage(state.page + 1);
      }
    });
  }

  /* ============================================================
     STICKY BAR
     ============================================================ */
  if (elBar) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        elBar.classList.toggle('is-stuck', !entry.isIntersecting);
      });
    }, { threshold: 0, rootMargin: '-1px 0px 0px 0px' });

    var sentinel = document.createElement('div');
    sentinel.style.height = '1px';
    sentinel.style.position = 'absolute';
    sentinel.style.top = '0';
    sentinel.style.left = '0';
    sentinel.style.right = '0';
    sentinel.style.pointerEvents = 'none';
    elBar.style.position = 'relative';
    elBar.parentElement.insertBefore(sentinel, elBar);
    observer.observe(sentinel);
    /* Fix: use actual sticky positioning */
    elBar.style.position = '';
  }

  /* ============================================================
     SIDEBAR TOGGLE (Desktop)
     ============================================================ */
  var toggleFiltersBtn = $('avora-shop-toggle-filters');
  if (toggleFiltersBtn && elSidebar) {
    toggleFiltersBtn.addEventListener('click', function () {
      /* On mobile, open the drawer instead */
      if (window.innerWidth < 1024) {
        openDrawer();
        return;
      }
      elSidebar.classList.toggle('is-hidden');
      toggleFiltersBtn.setAttribute('aria-expanded', !elSidebar.classList.contains('is-hidden'));
    });
  }

  /* Accordion collapse for filter headings */
  document.querySelectorAll('.avora-shop__filter-heading').forEach(function (heading) {
    heading.addEventListener('click', function () {
      var expanded = heading.getAttribute('aria-expanded') === 'true';
      heading.setAttribute('aria-expanded', !expanded);
    });
  });

  /* ============================================================
     MOBILE DRAWERS
     ============================================================ */
  function openDrawer() {
    /* Clone sidebar content into drawer body */
    if (elDrawerBody && elSidebar) {
      elDrawerBody.innerHTML = elSidebar.innerHTML;
      /* Re-bind events within drawer */
      bindDrawerFilters();
    }
    elDrawerOverlay.classList.add('is-open');
    elDrawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    elDrawerOverlay.classList.remove('is-open');
    elDrawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function bindDrawerFilters() {
    /* Category clicks in drawer */
    elDrawerBody.querySelectorAll('.avora-shop__cat-dept-btn').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        var handle = btn.dataset.handle;
        var expand = btn.querySelector('.avora-shop__cat-expand');
        var subs = btn.parentElement.querySelector('.avora-shop__cat-subs');
        if (e.target.closest('.avora-shop__cat-expand')) {
          if (expand) expand.classList.toggle('is-open');
          if (subs) subs.classList.toggle('is-open');
          return;
        }
        toggleArrayValue(state.categories, handle);
        state.page = 1;
        updateDrawerCount();
        update(false);
      });
    });

    elDrawerBody.querySelectorAll('.avora-shop__cat-sub-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        toggleArrayValue(state.categories, btn.dataset.handle);
        state.page = 1;
        updateDrawerCount();
        update(false);
      });
    });

    /* Checkbox filters in drawer */
    elDrawerBody.querySelectorAll('.avora-shop__check-label').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var section = btn.closest('.avora-shop__filter-section');
        var filter = section ? section.dataset.filter : '';
        var stateKey = filter === 'material' ? 'materials' : filter === 'room' ? 'rooms' : null;
        if (stateKey) {
          toggleArrayValue(state[stateKey], btn.dataset.value);
          btn.classList.toggle('is-active');
          state.page = 1;
          updateDrawerCount();
          update(false);
        }
      });
    });

    /* Color swatches in drawer */
    elDrawerBody.querySelectorAll('.avora-shop__color-swatch').forEach(function (btn) {
      btn.addEventListener('click', function () {
        toggleArrayValue(state.colors, btn.dataset.value);
        btn.classList.toggle('is-active');
        state.page = 1;
        updateDrawerCount();
        update(false);
      });
    });

    /* Accordion headings in drawer */
    elDrawerBody.querySelectorAll('.avora-shop__filter-heading').forEach(function (heading) {
      heading.addEventListener('click', function () {
        var expanded = heading.getAttribute('aria-expanded') === 'true';
        heading.setAttribute('aria-expanded', !expanded);
      });
    });
  }

  function updateDrawerCount() {
    var filtered = applyFilters();
    if (elDrawerCount) elDrawerCount.textContent = filtered.length;
  }

  if (elDrawerOverlay) elDrawerOverlay.addEventListener('click', closeDrawer);
  var drawerDone = $('avora-shop-drawer-done');
  if (drawerDone) drawerDone.addEventListener('click', closeDrawer);
  var drawerApply = $('avora-shop-drawer-apply');
  if (drawerApply) drawerApply.addEventListener('click', function () {
    closeDrawer();
    update(true);
  });

  /* Mobile sort drawer */
  var mobileSortBtn = $('avora-shop-mobile-sort-btn');
  if (mobileSortBtn) {
    mobileSortBtn.addEventListener('click', function () {
      elSortOverlay.classList.add('is-open');
      elSortDrawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
  }

  function closeSortDrawer() {
    elSortOverlay.classList.remove('is-open');
    elSortDrawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  if (elSortOverlay) elSortOverlay.addEventListener('click', closeSortDrawer);
  var sortDrawerDone = $('avora-shop-sort-drawer-done');
  if (sortDrawerDone) sortDrawerDone.addEventListener('click', closeSortDrawer);

  /* Sort option buttons in mobile drawer */
  document.querySelectorAll('.avora-shop__sort-option').forEach(function (opt) {
    opt.addEventListener('click', function () {
      state.sort = opt.dataset.sort;
      state.page = 1;
      if (sortLabel) sortLabel.textContent = 'Sort by: ' + sortLabels[state.sort];
      /* Update active states in both desktop and mobile */
      document.querySelectorAll('.avora-shop__sort-option').forEach(function (o) { o.classList.remove('is-active'); });
      document.querySelectorAll('.avora-shop__sort-option[data-sort="' + state.sort + '"]').forEach(function (o) { o.classList.add('is-active'); });
      if (sortMenu) {
        sortMenu.querySelectorAll('.avora-shop__bar-dropdown-item').forEach(function (i) { i.classList.remove('is-active'); });
        var match = sortMenu.querySelector('[data-sort="' + state.sort + '"]');
        if (match) match.classList.add('is-active');
      }
      closeSortDrawer();
      update(true);
    });
  });

  /* ============================================================
     MAIN UPDATE
     ============================================================ */
  function update(animate) {
    var filtered = applyFilters();
    var counts = computeCounts(filtered);

    /* Update product count */
    var countText = filtered.length + ' product' + (filtered.length !== 1 ? 's' : '');
    if (state.categories.length === 1) {
      var catLabel = state.categories[0];
      departments.forEach(function (d) {
        if (d.handle === state.categories[0]) catLabel = d.label;
        d.subs.forEach(function (s) { if (s.handle === state.categories[0]) catLabel = s.label; });
      });
      countText = filtered.length + ' product' + (filtered.length !== 1 ? 's' : '') + ' in ' + catLabel;
    }
    if (elCount) elCount.textContent = countText;
    var pageStart = (state.page - 1) * state.perPage;
    var pageEnd = Math.min(pageStart + state.perPage, filtered.length);
    if (elSidebarShowing) elSidebarShowing.textContent = filtered.length > 0 ? 'Showing ' + (pageStart + 1) + '–' + pageEnd + ' of ' + filtered.length : '';
    if (elDrawerCount) elDrawerCount.textContent = filtered.length;

    /* Render sidebar filters with updated counts */
    renderCategoryTree(counts);
    renderCheckboxFilter('avora-shop-material-filter', materials, 'materials', counts.materials);
    renderCheckboxFilter('avora-shop-room-filter', rooms, 'rooms', counts.rooms);
    renderColorFilter(counts.colors);

    /* Render pills */
    renderPills();

    /* Render grid */
    renderGrid(filtered, animate);

    /* Sync URL */
    syncToURL();
  }

  /* ============================================================
     INIT
     ============================================================ */
  restoreFromURL();
  elGrid.dataset.cols = state.gridCols;

  /* Set sort label from URL state */
  if (sortLabel && sortLabels[state.sort]) {
    sortLabel.textContent = 'Sort by: ' + sortLabels[state.sort];
  }
  if (sortMenu) {
    sortMenu.querySelectorAll('.avora-shop__bar-dropdown-item').forEach(function (i) {
      i.classList.toggle('is-active', i.dataset.sort === state.sort);
    });
  }

  initPriceSlider();
  update(false);

  /* Variant dot click — swap card image */
  document.addEventListener('click', function(e) {
    var dot = e.target.closest('.avora-card--shop__variant-dot');
    if (!dot) return;

    e.preventDefault();
    e.stopPropagation();

    var card = dot.closest('.avora-card--shop');
    var img = card.querySelector('.avora-card--shop__image');
    var index = parseInt(dot.dataset.variantIndex, 10);

    var images = [];
    try { images = JSON.parse(img.dataset.images); } catch(err) {}

    if (images[index]) {
      img.style.opacity = '0.3';
      img.src = images[index];
      img.onload = function() {
        img.style.opacity = '1';
      };
    }

    card.querySelectorAll('.avora-card--shop__variant-dot').forEach(function(d) {
      d.classList.remove('avora-card--shop__variant-dot--active');
    });
    dot.classList.add('avora-card--shop__variant-dot--active');
  });

  /* Back button support */
  window.addEventListener('popstate', function () {
    restoreFromURL();
    if (window._avoraShopPricePosition) window._avoraShopPricePosition();
    if (window._avoraShopPresetHighlight) window._avoraShopPresetHighlight();
    update(false);
  });

  /* ============================================================
     QUICK ADD — Shop card "+" button handler
     ============================================================ */
  window.avoraShopQuickAdd = function(btn) {
    if (btn.disabled || btn.classList.contains('is-loading')) return;
    var variantId = btn.dataset.variantId;
    if (!variantId) return;

    btn.classList.add('is-loading');
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
    })
    .then(function(res) {
      if (!res.ok) throw new Error('Add failed');
      return res.json();
    })
    .then(function() {
      btn.classList.add('is-added');
      btn.classList.remove('is-loading');

      /* Fly-to-cart */
      if (window.avoraFlyToCart) {
        var card = btn.closest('.avora-card--shop');
        var imgEl = card ? card.querySelector('.avora-card--shop__image') : null;
        window.avoraFlyToCart({
          imageEl: imgEl,
          imageSrc: btn.dataset.productImage || (imgEl ? imgEl.src : ''),
          title: btn.dataset.productTitle || '',
          price: btn.dataset.productPrice || '',
          sourceEl: btn
        });
      }

      /* Notify cart listeners */
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
      window.dispatchEvent(new CustomEvent('cart:update'));

      /* Update cart count */
      fetch('/cart.js', { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          document.querySelectorAll('.cart-count-badge, [data-cart-count], .cart-bubble__text-count').forEach(function(b) {
            b.textContent = cart.item_count;
          });
        });

      /* Revert after 1.5s */
      setTimeout(function() {
        btn.classList.remove('is-added');
        btn.disabled = false;
      }, 1500);
    })
    .catch(function() {
      btn.classList.remove('is-loading');
      btn.disabled = false;
    });
  };

})();
